import { ASANA_CLIENT_ID } from '@config/constants';
import type { IntegrationInstallInstructionsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';

import { useLayoutEffect } from 'react';

export default function AsanaInstallInstructions({
  onClose
}: IntegrationInstallInstructionsProps) {
  useLayoutEffect(() => {
    onClose();
    window.open(
      `https://app.asana.com/-/install_platform_ui_app?app_id=${ASANA_CLIENT_ID}`,
      '_blank'
    );
  }, [onClose]);
  return null;
}
